<template>
  <div
    class="justify-md-start justify-lg-start justify-xs-center justify-sm-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row d-flex align-md-start align-lg-start align-xl-start align-xs-center align-sm-center"
  >
    <v-avatar
      rounded="full"
      size="80"
      left
      color="primary"
      class="mr-xs-0 mr-sm-0 mr-md-4 mr-lg-4 mr-xl-4 my-xs-3 my-sm-3 my-md-0 my-lg-0 my-xl-0"
    >
      <v-img
        v-if="userAvatar"
        :src="userAvatar"
        :alt="userName"
        :lazy-src="require('@/assets/img/logo.png')"
        eager
      />
      <p v-else class="white--text text-h3 font-weight-semibold ma-auto">
        {{ userInitial }}
      </p>
    </v-avatar>
    <v-card outlined width="100%" rounded="lg">
      <v-card-text class="pa-0 ma-0">
        <Editor
          :isEditable="true"
          :content="null"
          ref="editor"
          style="width: 100%; height: 100%"
        />
      </v-card-text>
    </v-card>
    <v-btn
      color="primary"
      rounded
      depressed
      light
      large
      class="mx-4 my-xs-4 my-sm-4 my-md-1 my-lg-1 my-xl-1"
      :loading="isLoading"
      @click="postComment"
    >
      Post
    </v-btn>
  </div>
</template>

<script>
import Editor from '@/components/ViewForum/Editor.vue'
import { ANALYTICS } from '@/configs/firebase'
import { logEvent } from 'firebase/analytics'
import cleanCommentBody from '@/services/cleanCommentBody.js'
export default {
  name: 'NewComment',
  components: { Editor },
  props: ['topicId'],
  data: () => ({
    isLoading: false
  }),
  methods: {
    async postComment() {
      this.isLoading = true
      const content = this.$refs.editor.getContent()
      const cleanedContent = await cleanCommentBody(content);
      await this.$store.dispatch('comments/ADD_COMMENT', {
        topicId: this.topicId,
        body: cleanedContent
      })
      logEvent(ANALYTICS, 'commented_on_forum', {
        commenter: this.$store.getters['users/USER'].email
      })
      this.$refs.editor.clearContent()
      this.isLoading = false
    }
  },
  computed: {
    userAvatar() {
      const user = this.$store.getters['users/USER']
      if (!user.image) {
        return null
      }

      return user.image
    },
    userName() {
      const user = this.$store.getters['users/USER']
      if (!user.name) {
        return 'Anonymous'
      }

      return user.name
    },
    userInitial() {
      const user = this.$store.getters['users/USER']
      if (!user.name) {
        return '0'
      }

      return user.name.split(' ')[0].at(0)
    }
  }
}
</script>

<style></style>
